import { Component, Input } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { TemplateLayout } from '../../../types/badge.type'
import { CommonModule } from '@angular/common'
import { BadgeTemplateToolbarComponent } from '../badge-template-toolbar/badge-template-toolbar.component'
import { BadgeTemplateDesignAreaComponent } from '../badge-template-design-area/badge-template-design-area.component'

@Component({
  selector: 'app-badge-template-creation',
  templateUrl: './badge-template-creation.component.html',
  styleUrls: ['./badge-template-creation.component.scss'],
  standalone: true,
  imports: [CommonModule, BadgeTemplateToolbarComponent, BadgeTemplateDesignAreaComponent]
})
export class BadgeTemplateCreationComponent {
  @Input() public selectedTemplate!: TemplateLayout
  @Input() public badgeForm!: FormGroup
}
